/* assets/video-carousel.js
   Carrousel de vidéos — vanilla JS, sans dépendance.
   Gère : défilement par flèches/puces, lecture à la demande
   (vidéo Shopify, YouTube, Vimeo), pause des autres vidéos.
*/
(function () {
  'use strict';

  function initCarousel(root) {
    var track = root.querySelector('[data-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.video-carousel__slide'));
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    var dotsWrap = root.querySelector('[data-dots]');

    if (!track || slides.length === 0) return;

    // Combien de slides visibles à la fois (pour paginer les puces)
    function visibleCount() {
      var styles = getComputedStyle(root);
      var isDesktop = window.matchMedia('(min-width: 750px)').matches;
      var val = isDesktop ? styles.getPropertyValue('--vc-desktop') : styles.getPropertyValue('--vc-mobile');
      var n = parseInt(val, 10);
      return n > 0 ? n : 1;
    }

    // --- Puces de pagination ---
    var dots = [];
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      var perPage = visibleCount();
      var pageCount = Math.max(1, Math.ceil(slides.length / perPage));
      for (var i = 0; i < pageCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Aller au groupe de vidéos ' + (i + 1));
        dot.addEventListener('click', (function (index) {
          return function () {
            var target = slides[index * perPage];
            if (target) track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          };
        })(i));
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
      updateDots();
    }

    function updateDots() {
      if (!dots.length) return;
      var perPage = visibleCount();
      var index = Math.round(track.scrollLeft / (slides[0].offsetWidth + 16));
      var page = Math.min(dots.length - 1, Math.floor(index / perPage));
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === page ? 'true' : 'false');
      });
    }

    // --- Flèches ---
    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= max;
    }

    function scrollBySlides(direction) {
      var perPage = visibleCount();
      var amount = (slides[0].offsetWidth + 16) * perPage * direction;
      track.scrollBy({ left: amount, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollBySlides(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollBySlides(1); });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        updateDots();
        updateArrows();
      }, 80);
    });

    window.addEventListener('resize', function () {
      buildDots();
      updateArrows();
    });

    // --- Lecture des vidéos à la demande ---
    function stopAllPlayers() {
      root.querySelectorAll('[data-player]').forEach(function (player) {
        var video = player.querySelector('video');
        if (video) video.pause();
        var iframe = player.querySelector('iframe');
        if (iframe) iframe.src = iframe.src; // recharge = stoppe la lecture
        player.hidden = true;
        var poster = player.previousElementSibling;
        if (poster && poster.classList.contains('video-carousel__poster')) poster.hidden = false;
      });
    }

    slides.forEach(function (slide) {
      var playBtn = slide.querySelector('.video-carousel__play');
      var poster = slide.querySelector('[data-poster]');
      var player = slide.querySelector('[data-player]');
      if (!playBtn || !player) return;

      playBtn.addEventListener('click', function () {
        stopAllPlayers();

        var host = player.getAttribute('data-host');

        if (host === 'shopify') {
          var video = player.querySelector('video');
          poster.hidden = true;
          player.hidden = false;
          if (video) {
            video.play().catch(function () {});
          }
          return;
        }

        var videoId = player.getAttribute('data-video-id');
        if (!videoId) return;

        var iframe = player.querySelector('iframe');
        if (!iframe) {
          iframe = document.createElement('iframe');
          iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('frameborder', '0');
          player.appendChild(iframe);
        }

        if (host === 'youtube') {
          iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
        } else if (host === 'vimeo') {
          iframe.src = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';
        }

        poster.hidden = true;
        player.hidden = false;
      });
    });

    buildDots();
    updateArrows();
  }

  function init() {
    document.querySelectorAll('[data-video-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Compatibilité éditeur de thème (rechargement de section)
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-video-carousel]');
    if (section) initCarousel(section);
  });
})();